import React, { useState } from 'react';
import { validateFunctionalForm } from '../../utils';

const Login = (props) => {

    const { message } = props;
    const [state, setState] = useState({
        user_name: { name: 'user_name', value: '', isRequired: true, error: '' },
    });

    const onChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
                error: prevState[name].isRequired && !value ? 'This field is required' : ''
            }
        }));
    };


    const onSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {
                username: state.user_name.value,
            }
            props.onSubmit(model)
        }

    }
    return (
        <React.Fragment>
            <div
                className="alert alert-success text-center mb-4"
                role="alert"
                style={{ whiteSpace: 'nowrap' }}
            >
                {message ? message : 'Enter your Username and instructions will be sent to you!'}
            </div>


            {!message && <form className="form-horizontal" onSubmit={onSubmit}>

                <div className="mb-3">
                    <label for="username" className="form-label">Username</label>
                    <input
                        className={state.user_name.error ? "form-control is-invalid" : "form-control"}
                        type="text"
                        name={state.user_name.name}
                        value={state.user_name.value}
                        placeholder="demo"
                        onChange={onChange}
                    />
                </div>


                <div className="mt-3 d-grid">
                    <button
                        className="btn btn-primary waves-effect waves-light"
                        type="submit"
                        style={{ backgroundImage: "linear-gradient(90deg, #0ddcef, #319bfc)" }}
                    >
                        Send Instructions
                    </button>
                </div>
            </form>
            }
        </React.Fragment >
    );
}

export default Login;
